import { isNull, isUndefined } from 'lodash';

export const createPath = basePath =>
  /**
   * Curried path function
   * @param {Object} params - Path params
   * @param {Object} options - Additional options
   * @param {Object} options.searchParams - Search params to append to the path.
   *                 Accepts FormData, URLSearchParams or plain key-value objects.
   * @returns
   */
  (params = null, options = null) => {
    if (!params && !options) return basePath;

    let intermediatePath = basePath;

    if (params && typeof params === 'object') {
      Object.entries(params).forEach(([param, value]) => {
        if (!isNull(value) && !isUndefined(value)) {
          const re = new RegExp(
            `(.*)(:${param})(\\([^)]*\\))??(\\?)??(?=\\/|$)(.*)?`,
          );

          intermediatePath = intermediatePath.replace(re, `$1${value}$5`);
        }
      });
    }

    const finalBasePath = intermediatePath.replace(/\/:[^/?]*?\?/g, '');

    if (options && options.searchParams) {
      let searchParams = {};

      if (typeof options.searchParams === 'object') {
        if ('entries' in options.searchParams) {
          searchParams = Object.fromEntries(options.searchParams.entries());
        } else if (
          Object.getPrototypeOf(options.searchParams) === Object.prototype
        ) {
          searchParams = options.searchParams;
        }
      }

      const sp = new URLSearchParams(searchParams);

      return [finalBasePath, sp.toString()].filter(Boolean).join('?');
    }

    return finalBasePath;
  };

const Paths = {
  Login: createPath('/connexion'),
  RequestPassword: createPath('/request-password'),
  ResetPassword: createPath('/reset-password'),

  Home: createPath('/'),

  Contact: createPath('/contact'),

  Shop: createPath('/boutique'),
  SingleProduct: createPath('/boutique/articles/:productID'),
  SingleFamily: createPath('/boutique/:aisleID/:familyID/:page?'),
  SingleAisle: createPath('/boutique/:aisleID'),

  Cart: createPath('/panier'),
  OrderConfirmation: createPath('/commande/confirmation'),
  OrdersList: createPath('/commandes/:orderID?'),
  PendingOrdersList: createPath('/intentions-de-commande/:orderID?'),
  PreordersList: createPath('/precommandes/:preorderID?'),
  QuoteGenerator: createPath('/devis'),

  AdminIndex: createPath('/admin'),
  Admin: createPath('/admin/:resource/:id?/:userID?'),

  NotFound: createPath('/404'),
};

export default Paths;
